import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";
import chunkArray from "@/util/chunkArray.js";

const MAX_UPDATES_PER_REQUEST = 50;

const deleteBulk = async (module, { deletions, routeName, opts = {} }) => {
  const api = useApiStore();
  const { commit, dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);

  const chunks = chunkArray([...deletions], MAX_UPDATES_PER_REQUEST);
  await chunks.reduce(async (promise, chunk) => {
    await promise;

    await dispatch("httpRequest", {
      func: api.deleteBulk(chunk),
      config,
    });

    if (routeName === "Categories") {
      commit("removeCategories", chunk);
    }
    if (routeName === "SubCategories") {
      commit("removeSubCategories", chunk);
    }
    if (
      ["Category", "BulkCategoryEditor", "BulkRecordItemsEditor"].includes(
        routeName
      )
    ) {
      commit("removeEntries", chunk);
    }
  }, Promise.resolve());

  await dispatch("fetchCategoryTree");
};

export { deleteBulk };
